import getPageName from './getPageName';
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Pagination, Navigation]);

/* Добавление контента в блок "Отзывы наших выпускников"*/
const reviews = () => {
  const pageName = getPageName(),
    reviews = document.querySelector('.video-reviews__slides'),
    newFormatSlider = document.querySelector('[data-new-reviews]');

  if (!!reviews == false) return;

  async function parseReviews() {
    let response = await fetch('/files/reviews.json');
    let result = await response.json();

    result.forEach(function (el) {
      if (el.url == pageName) {
        createReviewsBlock(el.data);
      }
    });
  }

  function createReviewsBlock(data) {
    let content = '';

    data.forEach((item) => {
      if (item.video) {
        content += `
                    <li class="video-reviews__slide swiper-slide">
                        <figure class="video-reviews__slide-video">
                            <video width="278" height="424" preload="none" loading="lazy" poster="${item.poster}" muted="false" playsinline>
                                <source src="${item.video}" type="video/mp4">
                            </video>

                            <figcaption>${item.name}</figcaption>
                        </figure>
                        <a class="video-reviews__slide-play" data-fslightbox="review-${item.id}" href="${item.href}">Смотреть отзыв</a>
                    </li>
                `;
      } else {
        if (newFormatSlider){
          content += `
                    <li class="reviews-block swiper-slide">
                      <div class="reviews-block__wrap">
                          <img loading="lazy" src="${item.img}" alt="Отзывы">
                          <p class="reviews-block__name">${item.name}</p>
                          <p class="reviews-block__description">${item.content}</p>
                          <p class="reviews-block__unwrap" style = "display:none">Развернуть кейс</p>
                      </div>
                    </li>
                `;
        }
        else {
          content += `
                    <li class="reviews-block swiper-slide" style="background:url('${item.img}') no-repeat center">
                        <p class="reviews-block__name">${item.name}</p>
                        <p class="reviews-block__description">${item.content}</p>
                    </li>
                `;
        }
      }
    });

    reviews.innerHTML = content;
    refreshFsLightbox();

    (() => {
      const videoReviews = document.querySelectorAll('.video-reviews__slide');
      if (!videoReviews.length) return;

      videoReviews.forEach((videoReview) => {
        videoReview.addEventListener('mouseover', () => {
          videoReview.querySelector('video').play();
        });

        videoReview.addEventListener('mouseleave', () => {
          videoReview.querySelector('video').pause();
        });
      });
    })();

    setTimeout(() => {
      const slider = document.querySelector('.video-reviews__slider');
        

      if (newFormatSlider) {
        slider &&
          new Swiper(slider, {
            spaceBetween: 20,
            watchOverflow: true,
            breakpoints: {
              1280: {
                slidesPerView: 3,
              },
              768: {
                slidesPerView: 2,
              },
              0: {
                slidesPerView: 1,
              },
            },
            navigation: {
              nextEl:
                '.video-reviews__navigation .slider-navigation__button--next',
              prevEl:
                '.video-reviews__navigation .slider-navigation__button--prev',
            },
            pagination: {
              el: '.video-reviews__navigation .swiper-pagination',
              type: 'fraction',
            },
            a11y: {
              enabled: true,
              prevSlideMessage: 'Переход на предыдущий слайд',
              nextSlideMessage: 'Переход на следующий слайд',
            },
          });
      } else {
        slider &&
          new Swiper(slider, {
            spaceBetween: 20,
            loop: true,
            watchOverflow: true,
            breakpoints: {
              1280: {
                slidesPerView: 4,
              },
              768: {
                slidesPerView: 3,
              },
              350: {
                slidesPerView: 1.5,
              },
              0: {
                slidesPerView: 1,
              },
            },
            navigation: {
              nextEl:
                '.video-reviews__navigation .slider-navigation__button--next',
              prevEl:
                '.video-reviews__navigation .slider-navigation__button--prev',
            },
            pagination: {
              el: '.video-reviews__navigation .swiper-pagination',
              type: 'fraction',
            },
            a11y: {
              enabled: true,
              prevSlideMessage: 'Переход на предыдущий слайд',
              nextSlideMessage: 'Переход на следующий слайд',
            },
          });
      }
    }, 50);
  }

  parseReviews();
};

export default reviews;
